// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__jkGcy","productName":"Table_productName__1P1SZ"};